module.exports = __webpack_public_path__ + "img/13800.9bc6f08e.jpg";